import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.SpendTrackerSheet`

export default defineMessages({
  budgetTrackerHeader: {
    id: `${scope}.budgetTrackerHeader`,
    defaultMessage: 'Budgets',
  },
  spendTrackerHeader: {
    id: `${scope}.spendTrackerHeader`,
    defaultMessage: 'Spend Tracker',
  },
  hideBudgetTrackerButtonLabel: {
    id: `${scope}.hideBudgetTrackerButtonLabel`,
    defaultMessage: 'Hide Budgets',
  },
  hideSpendTrackerButtonLabel: {
    id: `${scope}.hideSpendTrackerButtonLabel`,
    defaultMessage: 'Hide Spend Tracker',
  },
  errorNotificationTitle: {
    id: `${scope}.errorNotificationTitle`,
    defaultMessage: 'Error',
  },
})
